import styles from './DemoExitModal.module.scss';

const MODAL_COPY = {
    manualEnd: {
        eyebrow: 'Demo Complete',
        title: 'Ready to continue beyond the guided demo?',
        description: 'You have seen the core flow. The full Prepal experience adds deeper SAT coverage, stronger progress tracking, and the complete product journey.',
        primaryLabel: 'Continue on StudyPrepal.com',
        secondaryLabel: 'Keep exploring demo',
    },
    restrictedArea: {
        eyebrow: 'Guided Demo',
        title: 'That area is outside the demo experience.',
        description: 'This demo is intentionally scoped to a smaller set of flows. To explore the full product and next-step options, continue on StudyPrepal.com.',
        primaryLabel: 'Open StudyPrepal.com',
        secondaryLabel: 'Back to demo dashboard',
    },
};

export default function DemoExitModal({
    open,
    variant = 'manualEnd',
    onPrimary,
    onSecondary,
    isPrimaryLoading = false,
}) {
    if (!open) return null;

    const copy = MODAL_COPY[variant] || MODAL_COPY.manualEnd;

    return (
        <div className={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="demo-exit-title">
            <div className={styles.modal}>
                <div className={styles.badge}>{copy.eyebrow}</div>
                <div className={styles.iconWrap}>
                    <div className={styles.iconOrb}>↗</div>
                </div>
                <h2 id="demo-exit-title" className={styles.title}>{copy.title}</h2>
                <p className={styles.description}>{copy.description}</p>
                <a
                    className={styles.link}
                    href="https://studyprepal.com"
                    target="_blank"
                    rel="noreferrer"
                >
                    studyprepal.com
                </a>
                <div className={styles.actions}>
                    <button
                        type="button"
                        className={styles.primaryButton}
                        onClick={onPrimary}
                        disabled={isPrimaryLoading}
                    >
                        {isPrimaryLoading ? 'Opening...' : copy.primaryLabel}
                    </button>
                    <button
                        type="button"
                        className={styles.secondaryButton}
                        onClick={onSecondary}
                        disabled={isPrimaryLoading}
                    >
                        {copy.secondaryLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}